import { Component } from '@angular/core';

@Component({
  selector: 'app-issued-documents-svg',
  standalone: true,
  template: `<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#EEF5D9" />
    <g clip-path="url(#clip0_8865_1733)">
      <mask
        id="mask0_8865_1733"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="16"
        height="16"
      >
        <rect x="4" y="4" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8865_1733)">
        <path
          d="M12.9258 10.0638V5H8.34639C8.11293 5.00071 7.88923 5.09598 7.72416 5.26498C7.55908 5.43399 7.46603 5.66301 7.46533 5.90203V18.0983C7.46603 18.3373 7.55908 18.5663 7.72416 18.7353C7.88923 18.9043 8.11293 18.9996 8.34639 19.0003H18.2068C18.4403 18.9996 18.664 18.9043 18.829 18.7353C18.9941 18.5663 19.0872 18.3373 19.0879 18.0983V10.0638H12.9258Z"
          fill="#009042"
        />
        <path
          d="M6.711 17.123C6.17987 17.1198 5.66513 16.9344 5.24909 16.5963C4.83305 16.2583 4.53975 15.7872 4.41608 15.2583C4.29241 14.7295 4.34553 14.1735 4.56694 13.6792C4.78834 13.1849 5.16525 12.7809 5.63738 12.5318C5.65551 11.8493 5.88725 11.1908 6.29847 10.6533C6.70969 10.1158 7.27865 9.72778 7.92154 9.54629C8.56442 9.3648 9.24724 9.3995 9.86941 9.64527C10.4916 9.89103 11.0202 10.3349 11.3774 10.9114C11.6559 10.7999 11.9516 10.7404 12.2506 10.7359C12.7763 10.7345 13.2886 10.9055 13.7125 11.2238C14.1364 11.5421 14.4496 11.9911 14.6062 12.5048C15.0034 12.7066 15.3375 13.0182 15.5706 13.4043C15.8037 13.7905 15.9265 14.2357 15.9251 14.6897C15.9262 15.2737 15.7217 15.8387 15.3492 16.281C14.9767 16.7234 14.461 17.0137 13.8966 17.0987V17.123H6.711Z"
          fill="#009042"
        />
        <path
          d="M14.3055 12.7565C14.2301 12.4326 14.0832 12.1307 13.8759 11.8741C13.6687 11.6174 13.4067 11.4129 13.1101 11.2762C12.8135 11.1395 12.4902 11.0743 12.1652 11.0856C11.8401 11.0969 11.5219 11.1844 11.235 11.3414C10.9558 10.7694 10.4962 10.3105 9.93057 10.0391C9.36498 9.76767 8.72649 9.69955 8.11839 9.84574C7.51029 9.99194 6.96815 10.3439 6.57967 10.8447C6.1912 11.3455 5.97911 11.9658 5.97773 12.6053C5.97773 12.6512 5.97773 12.6998 5.97773 12.7457C5.53459 12.9213 5.16534 13.2499 4.93391 13.6747C4.70249 14.0996 4.62345 14.5939 4.71048 15.0721C4.79752 15.5504 5.04515 15.9824 5.4105 16.2934C5.77584 16.6044 6.23592 16.7748 6.71106 16.7752H13.5537C14.0257 16.7729 14.4823 16.6028 14.8453 16.2941C15.2084 15.9853 15.4554 15.557 15.5442 15.0825C15.633 14.6079 15.558 14.1164 15.3321 13.6922C15.1061 13.2679 14.7433 12.9372 14.3055 12.7565Z"
          fill="white"
        />
        <path
          opacity="0.6"
          d="M13.6096 9.48043H19.0912L13.6096 5V9.48043Z"
          fill="black"
        />
        <path d="M13.6096 9.48043H19.0912L13.6096 5V9.48043Z" fill="#009042" />
        <path
          d="M9.58782 13.8608C9.86608 13.8608 10.0917 13.6298 10.0917 13.3449C10.0917 13.06 9.86608 12.8291 9.58782 12.8291C9.30956 12.8291 9.08398 13.06 9.08398 13.3449C9.08398 13.6298 9.30956 13.8608 9.58782 13.8608Z"
          fill="#009042"
        />
        <path
          d="M9.73368 13.5342H9.44087L9.10059 14.9736H10.0766L9.73368 13.5342Z"
          fill="#009042"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_8865_1733">
        <rect width="16" height="16" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg> `,
})
export class IssuedDocumentsSvgComponent {}
